import { PointItemCollection } from '@/modules/core/ui/models/PointItemCollection';
import { BaseDBTModel } from '/@/modules/core/app/models/abstracts/BaseDBTModel';
import { HubSpotProduct } from '/@/modules/hubspot/models/HubSpotProduct';
import { PointItem } from '@/modules/core/ui/models/PointItem';
export class HubSpotLineItem extends BaseDBTModel {
  id?: number;
  productId?: number;
  dealId?: number;
  propertyHsSku?: string;
  propertyPrice?: number;
  propertyHsRecurringBillingStartDate?: string;
  propertyDescription?: string;
  propertyProductDescription?: string;
  propertyHsPositionOnQuote?: string;
  propertyHsDiscountPercentage?: string;
  propertyCurrency?: string;
  propertyName?: string;
  propertyQuantity?: number;
  propertyHsObjectId?: string;
  propertyHsRecurringBillingPeriod?: number;
  propertyRecurringbillingfrequency?: number;
  propertyDiscount?: number;
  propertyPurchaseTerm?: string;
  isDeleted?: boolean;
  product?: Relationship<HubSpotProduct>;
  propertyProductInclusions?: string;
  stripeProductId?: string;
  propertyConnectedAccount?: string;
  propertyConnectedAccountFee?: number;

  constructor(model: Partial<HubSpotLineItem> = {}) {
    super(model);

    this.id = model.id;
    this.productId = model.productId;
    this.dealId = model.dealId;
    this.propertyName = model.propertyName;
    this.propertyHsSku = model.propertyHsSku;
    this.propertyPrice = model.propertyPrice;
    this.propertyHsRecurringBillingStartDate = model.propertyHsRecurringBillingStartDate;
    this.propertyDescription = model.propertyDescription;
    this.propertyProductDescription = model.propertyProductDescription;
    this.propertyHsPositionOnQuote = model.propertyHsPositionOnQuote;
    this.propertyHsDiscountPercentage = model.propertyHsDiscountPercentage;
    this.propertyDiscount = model.propertyDiscount;
    this.propertyQuantity = model.propertyQuantity;
    this.propertyHsObjectId = model.propertyHsObjectId;
    this.propertyHsRecurringBillingPeriod = model.propertyHsRecurringBillingPeriod;
    this.propertyRecurringbillingfrequency = model.propertyRecurringbillingfrequency;
    this.propertyPurchaseTerm = model.propertyPurchaseTerm;
    this.isDeleted = model.isDeleted;
    this.propertyProductInclusions = model.propertyProductInclusions;
    this.propertyConnectedAccount = model.propertyConnectedAccount;
    this.propertyConnectedAccountFee = model.propertyConnectedAccountFee;
    this.product = HubSpotProduct.mapModelOrNull(model.product) ?? undefined;
    this.stripeProductId = model.stripeProductId;
  }

  get priceInCents(): number {
    return (this.propertyPrice ?? this.product?.propertyPrice ?? 0) * 100;
  }

  getValueInCents(runningTotal: number | null = null): number {
    if (this.product?.propertyIsCoupon) {
      return this.product.propertyAmountDiscountOff
        ? this.product.propertyAmountDiscountOff * 100
        : (runningTotal ?? 0) * (this.product.propertyPercentageDiscountOff / 100);
    }

    return this.priceInCents;
  }

  get productInclusions(): PointItem[] | undefined {
    return PointItemCollection.mapFromText(this.propertyProductInclusions).items;
  }
}
